import { render, staticRenderFns } from "./formWizardStep.vue?vue&type=template&id=c916470a&"
import script from "./formWizardStep.vue?vue&type=script&lang=js&"
export * from "./formWizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports